import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login, registraUtente } from '../../actions/auth';


const LoginUtente = ({ login, isAuthenticated, registraUtente }) => {



    const [formData, setFormData] = useState({
        username: '',
        password: '',
        codiceDispositivo: '',
        nuovoNome: ''
    });
    const [redirectAdmin, setRedirectAdmin] = useState(false)
    const [nuovaRegistrazione, setNuovaRegistrazione] = useState(false)


    const { username, password, codiceDispositivo, nuovoNome } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
  

    
    const onSubmit = async e => {
        e.preventDefault();
        if (username.trim().toLowerCase() === 'jolly' && password === '15') {
            setNuovaRegistrazione(true)
        } else {
            login({ username, password, codiceDispositivo });
        }
    };

    const onSubmitRegistrazione = async e => {
        e.preventDefault();
        registraUtente({ username: nuovoNome, password, codiceDispositivo });

    };

    if (isAuthenticated) {
        return <Redirect to="/" />
    }
    if(redirectAdmin){
        return <Redirect to="/admin" />
    }


    return (
        <section className="fd-section wide bg-prim">
            <div className="w-layout-blockcontainer fd-container fd-window-w w-container">
                <div className="fd-wrap">
                    <div className="space-20"></div>
                    <img src="/assets/media/noi_con_voi-fondazione_danesino-logo.svg" alt="" className="image" data-savepage-loading="lazy" />
                    <div className="space-40"></div>
                    <div className="fd-form w-form">
                    {nuovaRegistrazione ?
                    <form id="email-form" name="email-form" data-name="Email Form" data-wf-page-id="677af35aeb367078c9ef9568" data-wf-element-id="206960bc-98cd-9bec-5c67-bb4157349c75" aria-label="Email Form"  onSubmit={e => onSubmitRegistrazione(e)}>
                            <label htmlFor="NuovoNome">Inserisci il tuo nome e le prime 2 lettere del tuo cognome</label>
                            <input className="input w-input" maxLength="256" name="nuovoNome" data-name="nuovoNome" placeholder="Inserisci il tuo nome" type="text" id="nuovoNome" required={true} value={nuovoNome} onChange={e => onChange(e)}/>
                            <input type="submit" data-wait="Un attimo..." className="submit-button w-button" value="Accedi" />
                    </form>
                    :
                    <form id="email-form" name="email-form" data-name="Email Form" data-wf-page-id="677af35aeb367078c9ef9568" data-wf-element-id="206960bc-98cd-9bec-5c67-bb4157349c75" aria-label="Email Form"  onSubmit={e => onSubmit(e)}>
                            <label htmlFor="Username">Come ti chiami?</label>
                            <input className="input w-input" maxLength="256" name="username" data-name="username" placeholder="Inserisci il tuo nome" type="text" id="username" required={true} value={username} onChange={e => onChange(e)}/>
                            <label htmlFor="Password">Password</label>
                            <input className="input w-input" maxLength="256" name="password" data-name="password" placeholder="Inserisci password" type="text" id="password" required={true} value={password} onChange={e => onChange(e)}/>
                            {false ? 
                            <><label htmlFor="CodiceDispositivo">Codice dispositivo</label>
                            <input className="input w-input" maxLength="256" name="codiceDispositivo" data-name="codiceDispositivo" placeholder="Inserisci codice dispositivo" type="text" id="codiceDispositivo" value={codiceDispositivo} onChange={e => onChange(e)}/>
                            </>
                            : ''}
                            <input type="submit" data-wait="Un attimo..." className="submit-button w-button" value="Invia e procedi" />
                    </form>
                    }
                        <div className='link_info'>
                            <a href="https://www.fondazionedanesino.it/contatti/" target="_blank"> Vuoi maggiori informazioni? Sei interessato a questo progetto? Clicca qui</a>
                        </div>
                    </div>
                <div className="space-20"></div>
                </div>
            </div>
        </section>
    )
};

LoginUtente.propTypes = {
    login: PropTypes.func.isRequired,
    registraUtente: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { login, registraUtente })(LoginUtente);